'use strict';

var styleInject_es = require('../../../../node_modules/style-inject/dist/style-inject.es.js');

var css_248z = ".varta-img {\n  display: block;\n  width: 100%; }\n  .varta-img__img {\n    display: block;\n    width: 100%;\n    height: auto; }\n  .varta-img__animate {\n    transform: translate3d(0, 100px, 0);\n    will-change: transform;\n    transition: transform 1s cubic-bezier(0.02, 0.25, 0.12, 0.99); }\n    .varta-img__animate--in {\n      transform: translate3d(0, 0, 0); }\n";
styleInject_es(css_248z);
